export default "__VITE_ASSET__76ab9826__"